import { Component, AfterContentInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.css']
})
export class ContentComponent implements AfterContentInit {

  constructor(private router: ActivatedRoute, private httpClient: HttpClient) { }
  public speakerdetails:any = [];
  public speakerSrc:any = [];

  public setPost(id: any) {
    this.speakerdetails = this.speakerSrc.filter((item: { id: any; }) => { return item.id == id });
  }

  ngAfterContentInit(): void {
    
    this.httpClient.get('/api/trainingspeakers').subscribe(
      data=>{
        this.speakerSrc = data
        this.setPost(this.router.snapshot.params.id);
      }
    );
  }

}
